module.exports = __webpack_public_path__ + "static/media/logo-digix-branco.1f3c4911.svg";